import React from "react";
import _ from "lodash";
import FileViewer from 'react-file-viewer';
import IFrame from 'react-iframe';
import ReactPlayer from "react-player";
import { useSelector } from 'react-redux';
import PDFShow from "../components/PDFShow";
import { mimeTypeExtensionByType } from "../utils/common";

const CustomUnsupportedViewer = props => (
  <div className="pg-driver-view">
    <div className="unsupported-message">
      <p className="alert"><b>Sorry, no preview for {`.${props.fileType}`}</b></p>
    </div>
  </div>
);

const FileViewMaster = props => {
  const settings = useSelector(({ settings }) => settings);

  // const load_js = () => {
  //   const head= document.getElementsByTagName('head')[0];

  //   const dflipScript = document.getElementById('dflip_script');
  //   if (dflipScript) {
  //     head.removeChild(dflipScript);
  //   }

  //   const script= document.createElement('script');
  //   script.src= '/dflip/js/dflip.min.js';
  //   script.id = 'dflip_script';
  //   head.appendChild(script);
  // };

  // React.useEffect(() => {
  //   load_js();
  // }, []);

  /**
   * Given the details object, extract the ext if it exists or examine the mime type if it exists
   * or fallback to 'file'
   * @param {Object} details 
   */
  const getExtensionForFileDetails = (details) => {
    let currentExtension = _.get(details, 'ext', '');
    if (currentExtension) {
      return currentExtension;
    }

    //otherwise figure it out from mimetype
    const mimeType = _.get(details, 'mime', '');
    currentExtension = mimeTypeExtensionByType(mimeType);

    return currentExtension;
  }

  let fileType = getExtensionForFileDetails(props.details);

  const selectFileViewer = () => {
    let detailsUrl = _.get(props, 'details.urls.ssl', null);
    const sourceUrl = _.get(props, 'details.urls.source', null); // we have a link
    
    // massage for videos
    if (sourceUrl) {
      const ogType = _.get(props, 'details.meta.ogType', null); // we have a link
      if (sourceUrl.includes("youtube.com") 
      || sourceUrl.includes("youtu.be") 
      || sourceUrl.includes("vimeo.com")
      || (ogType && ogType.includes("video"))) {
        fileType = "video";
      }
    } 
    
    switch (fileType) {
      case "pdf":
        return (
          <PDFShow url={detailsUrl} />
          // <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          //   <div
          //     className="_df_book"
          //     height="100%"
          //     webgl="true"
          //     backgroundcolor={_.get(settings, 'brandingOption.color', 'tear')}
          //     source={detailsUrl}
          //     id="df_manual_book"
          //   />
          // </div>
        );
      case "video":
        return (
          <ReactPlayer className="video-player" 
            url={sourceUrl}
            width="540px"
            height="303px"
            controls
          />
        );
        case "mp4":
        case "mpg":
        case "mov":
        case "m4v":
          return (
            <ReactPlayer className="video-player" 
              url={detailsUrl}
              width="540px"
              height="303px"
              controls
            />
          );
        case "xlsx":
          return (
            <p>File preview not available</p>
          );
        case "html":
          const viewUrl = sourceUrl || detailsUrl;
          return (
            <IFrame url={viewUrl}
              width="100%"
              height="100%"
              id="iframeContent"
              display="initial"
              position="relative"/>
          );
        case "doc":
        case "docm":
        case "ppt":
        case "pptx":
        case "xls":
        case "psd":
          return (
            <IFrame url={`https://view.officeapps.live.com/op/view.aspx?src=${detailsUrl}`}
              width="100%"
              height="100%"
              id="iframeContent"
              display="initial"
              position="relative"/>
          );
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
        case "svg":
        case "webp":
          return (
              <img src={detailsUrl} 
              alt="preview" />
          );
        case "heic":
          // use web version of the image
          detailsUrl = _.get(props, 'details.web.url', null);
          return (
              <img src={detailsUrl} 
              alt="preview" />
          );
      default:
        return (
          <FileViewer
            fileType={_.get(props, "details.ext", null)}
            filePath={detailsUrl}
            onError={onError}
            unsupportedComponent={CustomUnsupportedViewer}
          />
        )
    }
  }

  const onError = (error) => {
    console.log({functionName: "FileViewMaster", error: error.toString()});
  }

  return (
    <div className="file-content" style={{ backgroundColor: fileType === 'pdf' ? _.get(settings, 'brandingOption.color', 'transparent') : 'transparent' }}>
      <div className="file-content-viewer">
        { selectFileViewer() }
      </div>
    </div>
  );
}

export default FileViewMaster;
